import Column from '@components/Column';
import CustomerServiceIcon from '@icons/CustomerServiceIcon';
import PencilFill from '@icons/edit/PencilFill';
import MobileLine from '@icons/phone/MobileLine';
import { useFlow } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CsItem from './CsItem';
import useInquiryInfo from './hooks/useInquiryInfo';

function CsContents() {
    const { t } = useTranslation('customerService');
    const { push } = useFlow();
    const { inquiryInfo, externalContent, phoneContent } = useInquiryInfo();
    if (inquiryInfo) {
        return (
            <Column fullWidth spacing={4}>
                {inquiryInfo.inAppInquiryEnabled && (
                    <CsItem icon={PencilFill}
                        title={t('menu.inquiry')}
                        content={inquiryInfo.inAppNote}
                        onClick={() => push('InquiryActivity', { type: 'WRITE' })} />
                )}
                {inquiryInfo.phoneEnabled && (
                    <CsItem icon={MobileLine}
                        title={t('menu.phone')}
                        content={phoneContent}
                        onClick={() => openExternalLink(`tel:${inquiryInfo?.phoneNumber}`)} />
                )}
                {inquiryInfo.externalInquiryEnabled && (
                    <CsItem icon={CustomerServiceIcon}
                        title={t('menu.external')}
                        content={externalContent}
                        onClick={() => openExternalLink(inquiryInfo.externalInquiryUrl!)} />
                )}
            </Column>
        );
    }
    return (<Fragment/>);
}

export default CsContents;
